export default function AuroraBrandHeader({ onPhoto = true, className = "" }) {
  const wordmark = onPhoto
    ? "/assets/aurora-brand/aurora-wordmark-white.png"
    : "/assets/aurora-brand/aurora-wordmark-blue.png";
  const mark = onPhoto
    ? "/assets/aurora-brand/aurora-mark-white.png"
    : "/assets/aurora-brand/aurora-mark-blue.png";

  return (
    <div className={`flex items-center gap-3 min-w-0 ${className}`}>
      <img
        src={mark}
        alt="Aurora Geriátrica"
        className="h-10 w-10 shrink-0 object-contain sm:hidden"
      />
      <img
        src={wordmark}
        alt="Aurora Geriátrica"
        className="hidden sm:block h-10 lg:h-12 max-w-[min(70vw,280px)] w-auto object-contain"
      />
    </div>
  );
}
